import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import CatalogOrderRoot from './CatalogOrderRoot'

const CatalogOrderComponent = (props) => {
  const queryClient = props.queryClient || new QueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <CatalogOrderRoot {...props} />
    </QueryClientProvider>
  )
}

CatalogOrderComponent.propTypes = {
  businessArea: PropTypes.oneOf(['sprachreisen', 'schueleraustausch']).isRequired,
  apiUrl: PropTypes.string.isRequired,
  apiToken: PropTypes.string.isRequired,
  crmApiUrl: PropTypes.string.isRequired,
  crmApiToken: PropTypes.string.isRequired,
  organisationId: PropTypes.string.isRequired,
  exchangeCountryCode: PropTypes.string,
  organisationSorter: PropTypes.func,
  interestInSchoolPrograms: PropTypes.bool,
  programId: PropTypes.string,
  referrer: PropTypes.string,
  headline: PropTypes.string,
  subline: PropTypes.string,
  teaser: PropTypes.string,
  upsell: PropTypes.bool.isRequired,
  upsellPrechecked: PropTypes.bool.isRequired,
  queryClient: PropTypes.instanceOf(QueryClient),
  onFinish: PropTypes.func.isRequired,
  onReady: PropTypes.func,
  afterSubmit: PropTypes.func,
}

export default CatalogOrderComponent
